import type { ComponentType } from 'react';
import { lazy, Suspense } from 'react';

const isDevelopment = import.meta.env.DEV;
const isMockDataEnabled = import.meta.env.VITE_MOCK_DATA === 'true';
const isMockScenarioHelperVisible =
  import.meta.env.VITE_SHOW_MOCK_SCENARIO_HELPER === 'true';

const shouldShowMockScenarioHelper =
  isDevelopment && isMockDataEnabled && isMockScenarioHelperVisible;

const MockScenarioHelper = shouldShowMockScenarioHelper
  ? lazy(() => import('../MockScenarioHelper/index'))
  : ((() => null) as ComponentType);

export default function MockScenarioHelperSlot() {
  return (
    <Suspense fallback={null}>
      <MockScenarioHelper />
    </Suspense>
  );
}
